// This is the entry point of the entire React application
// It finds the root HTML element and renders the App component into it

import React from 'react'; // React library for building user interfaces
import ReactDOM from 'react-dom/client'; // ReactDOM library for rendering React components to the web page
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap CSS - load before our styles to allow overrides
import './index.css'; // Global CSS styles and design system (overrides Bootstrap variables)
import './App.css'; // App layout shell
import './MyNavbar.css'; // Navigation bar styling
import './Home.css'; // Home page styling
import './Login.css'; // Login page styling
import './Scoreboard.css'; // Scoreboard page styling
import './MinProfil.css'; // Profile page styling
import './Bilder.css'; // Images/gallery styling
import './Regler.css'; // Rules page styling
import './Profiler.css'; // Member directory styling
import './PublicProfile.css'; // Public profile styling
import './Sc_BesteEng.css'; // Best organizer rankings
import './Sc_BesteDelta.css'; // Best participant rankings
import './Sc_MinePoeng.css'; // My points page
import './Hjem.css'; // Hjem welcome page
import './Blatur.css'; // Blåtur pages
import './Admin.css'; // Admin and invitation pages
import './design.css'; // Design layer: editorial page titles and cards (keep last)
import App from './App'; // The main App component that contains all pages and routing
import reportWebVitals from './reportWebVitals'; // Tool to measure app performance

// Find the HTML element with id="root" and create a React root
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the App component into the root element
root.render(
  <React.StrictMode>
    {/* React.StrictMode helps find potential problems in the app during development */}
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
